import { type FC, type PropsWithChildren, useId } from 'react';

import { Box, RadioCard, Stretch } from '@eneco/sparky';

import { ProductCardContent, type ProductCardContentProps } from './ProductCardContent';

interface Props extends Omit<ProductCardContentProps, 'id' | 'titlePrefix'> {
  id: string;
  isOpen?: boolean;
}

export const ProductCard: FC<PropsWithChildren<Props>> = ({
  id: productId,
  title,
  ribbon,
  touRibbon,
  tag,
  price,
  isOpen,
  usps,
  children,
}) => {
  const id = useId();
  const WrapperComponent = isOpen ? Box : Stretch;

  return (
    <WrapperComponent>
      <RadioCard value={productId} ariaLabelledby={`${id}-label ${id}-price`}>
        <ProductCardContent
          id={id}
          title={title}
          ribbon={ribbon}
          touRibbon={touRibbon}
          tag={tag}
          price={price}
          usps={usps}
          titlePrefix={
            <Box paddingTop="1">
              <RadioCard.Indicator />
            </Box>
          }>
          {children}
        </ProductCardContent>
      </RadioCard>
    </WrapperComponent>
  );
};
